<template>
  <Adminlte>
      <div class="box box-primary center-block">
        <div class="box-header with-border">
          <i class="fa fa-table font-dark"></i>
          <h3 class="box-title">Exportação de dados - Informações Gerais dos Parques</h3>
        </div>

        <section class="content">
          <div class="row main-row">
            <div class="col-xs-12 col-md-6">
              <div class="inner-box">
                <ParksFilter :parks="parks" :disabled="waitingDownload" />
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="inner-box">
                <h4>Filtrar Parques concebidos a partir de</h4>
                <div class="form-group">
                  <div class="center-inside-col">
                    <select v-model="selectedYear" class="form-control" :disabled="waitingDownload">
                      <option v-for="year in availableYears" :value="year">{{ year }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <button
                class="btn btn-block btn-success"
                @click="handleDownloadClick"
                :disabled="waitingDownload || selectedParksIds.length === 0"
              >
                Baixar arquivo em formato Excel &nbsp;
                <i class="fa fa-refresh fa-spin" v-if="waitingDownload"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ParksFilter from './ParksFilter'
  import { BackendApi } from '@/services/backend_api'
  import { saveAs } from 'file-saver'

  const FIRST_AVAILABLE_YEAR = 1980

  export default {
    name: 'ExportGeneralInformation',
    components: { Adminlte, ParksFilter },
    data: function () {
      return {
        parks: [],
        selectedYear: FIRST_AVAILABLE_YEAR,
        waitingDownload: false
      }
    },
    async mounted () {
      this.parks = await this.getParks()
    },
    methods: {
      async getParks () {
        const response = await BackendApi.getAnonymousClient().get('/parks/that-answered-general-information-quiz?hideLogo=true&orderBy=name&limit=0')
        const parksResponseWithNoLinksNeitherTotalElements = Object.values(response.data).slice(0, -2)
        return parksResponseWithNoLinksNeitherTotalElements.map((park) =>
          Object.assign({ isSelected: true }, park)
        )
      },
      handleDownloadClick (e) {
        e.preventDefault()

        const queryParams = {
          parks: this.selectedParksIds.join(','),
          year: this.selectedYear
        }

        this.waitingDownload = true
        BackendApi.getClient().get('/spreadsheet/general-information', {
          params: queryParams, responseType: 'blob'
        }).then((response) => {
          saveAs(response.data, 'general-information.xlsx')
        }).finally(() => {
          this.waitingDownload = false
        })
      }
    },
    computed: {
      availableYears: function () {
        const currentYear = (new Date()).getFullYear()

        let years = []
        for (let i = currentYear; i >= FIRST_AVAILABLE_YEAR; i--) {
          years.push(i)
        }
        return years
      },
      selectedParksIds: function () {
        return this.parks.filter((park) => park.isSelected).map((park) => park.id)
      }
    }
  }
</script>

<style scoped>
  .inner-box {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 10px;
    margin-bottom: 15px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// ExportGeneralInformation.vue?a282e394